import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts';
import { useEffect, useState } from "react";
import {createClient} from "../../client/Client";
import moment from "moment";

interface Process {} // Todo: fill up the process interface
interface Thread {} // Todo: fill up the thread interface


function UsageCharts({url}) {
  
  let [data, setData] = useState<any | undefined>({title: 'Loading',});
  
  
  useEffect(() => {
    const RestClient = createClient(url);
    RestClient.get('/status/monitors').then(resp => {
      
      const series = [];
      const pointInterval = 30 * 1000;
      let dateStart = null;
      const getProcessSeries = (process, thread) => {
        const seriesName = `${process.label} ${thread.id}`;
        if(!dateStart) dateStart = moment(process.createdAt).utc();
        
        if(!series.find(s => s.name == seriesName)) {
          series.push({
            name: seriesName,
            data: [],
            pointStart: dateStart,
            pointInterval
          })
        }

        return series.find(s => s.name == seriesName);
      }
      console.log("Monitors Response:", resp);
      const responseData: Array<any> = resp.data;

      responseData.forEach(process => {
        process.threads.forEach((thread) => {
          let series = getProcessSeries(process, thread);
          series.data.push (thread.busy ? 1 : 0);
        });


      });
      console.log("series", series);
      const chartData = {
        
        title: "Compiler Process Thread",
        yAxis: {
          title: 'Activity',
          min: 0, 
          max: 1
        },
        xAxis: {
          type: 'datetime',
          tickInterval: 1000 * 60 * 30,
          labels: {
              format: '{value:%m/%y/%d %H:%M:%S}',
              align: 'left'
          }
        },
        series
      };

      console.log("chartData:", chartData);
      setData(chartData);
    });
  }, []);


  return (
  <div>
    <HighchartsReact
      highcharts={Highcharts}
      options={data}/>
  </div>)
}

export default UsageCharts;